import { connectRouter } from 'connected-react-router';
import type { History } from 'history';
import { combineReducers } from 'redux';

import type { AppRootReducer } from '~/@types/app-types';
import { features } from '~/features';
import { commonStore } from '~/store/common-store';

export const createRootReducer = <T>(history: History<T>) => {
    const commonReducers = Object.values(commonStore).reduce(
        (acc, { reducer, name }) => ({
            ...acc,
            [name]: reducer,
        }),
        {}
    );

    const featureReducers = Object.values(features).reduce(
        (acc, { reducer, name }) => ({
            ...acc,
            [name]: reducer,
        }),
        {}
    );

    return (combineReducers({
        ...featureReducers,
        ...commonReducers,
        router: connectRouter<T>(history),
    }) as any) as AppRootReducer;
};
